<template>
    <div class="services-dashboard">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Serviços</mu-title>

        <!-- Lista das opções -->
        <mu-options :options="options"></mu-options>

    </div>
</template>

<script>
    import Menu from '@/config/menu'

    let MenuOptions = Menu.find('services')

    export default {
        name: 'app-services-dashboard',
        data () {
            return {
                options: MenuOptions
            }
        }
    }
</script>
